export const host = "20.79.65.152"
export const uri = "api/v1/"

export const port = "80"


export const azure_client_id = "4177acfc-951f-4702-8add-6425ffccf44c"

export const endpoint = `http://${host}:${port}/${uri}`
